(() => {
  const STORAGE_KEY = 'doyo-scroll-restoration-v1';
  const MAX_ENTRIES = 30;
  const RESTORE_DELAYS = [0, 100, 500, 1500];
  const RESTORE_TOLERANCE = 4;

  const getCurrentUrl = () => window.location.href;

  const readPositions = () => {
    try {
      const value = sessionStorage.getItem(STORAGE_KEY);
      if (!value) return {};

      const positions = JSON.parse(value);
      return positions && typeof positions === 'object' ? positions : {};
    } catch {
      return {};
    }
  };

  const writePositions = (positions) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
    } catch {
      // Storage can be unavailable in restricted WebViews; native behavior remains intact.
    }
  };

  const savePosition = () => {
    const positions = readPositions();
    const url = getCurrentUrl();

    positions[url] = {
      scrollY: Math.max(0, Math.round(window.scrollY || document.scrollingElement?.scrollTop || 0)),
      savedAt: Date.now(),
    };

    const entries = Object.entries(positions)
      .sort(([, first], [, second]) => (second.savedAt || 0) - (first.savedAt || 0))
      .slice(0, MAX_ENTRIES);

    writePositions(Object.fromEntries(entries));
  };

  const getSavedPosition = () => {
    const position = readPositions()[getCurrentUrl()];
    const scrollY = Number(position?.scrollY);

    return Number.isFinite(scrollY) && scrollY > RESTORE_TOLERANCE ? scrollY : null;
  };

  const restorePosition = (event) => {
    if (!event.persisted) return;

    const savedScrollY = getSavedPosition();
    if (savedScrollY === null) return;

    let userInteracted = false;
    const cancelRestore = () => {
      userInteracted = true;
    };
    const interactionEvents = ['pointerdown', 'touchstart', 'wheel', 'keydown'];

    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, cancelRestore, { once: true, passive: true });
    });

    RESTORE_DELAYS.forEach((delay) => {
      window.setTimeout(() => {
        if (userInteracted) return;

        const currentScrollY = window.scrollY || document.scrollingElement?.scrollTop || 0;
        if (Math.abs(currentScrollY - savedScrollY) > RESTORE_TOLERANCE) {
          window.scrollTo(0, savedScrollY);
        }

        if (delay === RESTORE_DELAYS[RESTORE_DELAYS.length - 1]) {
          interactionEvents.forEach((eventName) => {
            window.removeEventListener(eventName, cancelRestore);
          });
        }
      }, delay);
    });
  };

  window.addEventListener('pagehide', savePosition, { passive: true });
  window.addEventListener('pageshow', restorePosition);
})();
